import React, { Component } from 'react';

import SectionTitle from './Section/SectionTitle';
import SectionBar from './Section/SectionBar';
// import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';

class SectionContact extends Component {

  render() {
    const { width } = this.props;
    return (
      <section id="contact" className="Section SectionContact" style={this.props.style || {}}>
            <SectionTitle title={'Contact'} icon={'contact'} color={'#fff'} align={'right'} titleSize={width}/>

            <SectionBar length={'100%'} style={{marginLeft: 0}} color={'#fff'} direction={'vertical'}/>
            <div className="content">
              <Slide bottom>
                <img src={require('@assets/images/bg_map.png')} alt="" />
              </Slide>
            </div>
            <div className="bg left"></div>
            <div className="bg right"></div>
      </section>
    );
  }
}

export default SectionContact;



// WEBPACK FOOTER //
// ./src/components/Home/SectionContact.jsx